import * as React from "react";
import PropTypes from "prop-types";
import { getImage, GatsbyImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

class BioImage extends React.Component {

    render() {
        const { image, description, imageAlt, linkTo } = this.props;
        const displayableImage = getImage(image) || image;

        return <div key="bio" className="customContainer column is-6">
            <Link to={linkTo}>
                <GatsbyImage
                    image={displayableImage}
                    imgClassName="bioImage"
                    alt={imageAlt}
                />
                <div class="centered styledLink">{description}</div>
            </Link>
        </div>
    }
}

BioImage.propTypes = {
    image: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    description: PropTypes.string,
    imageAlt: PropTypes.string,
    linkTo: PropTypes.string,
};

export default BioImage;
